import type { Record, StorageDriver, StorageOperations } from '../types';

export function storageOperations<T>(
  key: string,
  driver: StorageDriver
): StorageOperations<T> {
  function isExpired(expiresIn?: number) {
    const raw = driver.getItem(key);

    if (!raw || expiresIn === undefined || expiresIn === -1) {
      return false;
    }

    const { timestamp } = JSON.parse(raw) as Record<T>;

    return Math.floor(Date.now() / 1000) >= timestamp + Number(expiresIn);
  }

  function get(expiresIn?: number) {
    const raw = driver.getItem(key);

    if (!raw || isExpired(expiresIn)) {
      return undefined;
    }

    const { value } = JSON.parse(raw) as Record<T>;

    return value;
  }

  function getTimestamp(expiresIn?: number) {
    const raw = driver.getItem(key);

    if (!raw || isExpired(expiresIn)) {
      return undefined;
    }

    const { timestamp } = JSON.parse(raw) as Record<T>;

    return timestamp;
  }

  function set(value: T | undefined) {
    const data = {
      value,
      timestamp: Math.floor(Date.now() / 1000)
    };

    driver.setItem(key, JSON.stringify(data));
  }

  function remove() {
    driver.removeItem(key);
  }

  return {
    get,
    set,
    remove,
    isExpired,
    getTimestamp
  } as StorageOperations<T>;
}
